export default {
    state: {
        alturas: [],
    },
    getters: {
        alturas: state => state.alturas || [],
    },
    mutations: {
        SET_ALTURAS: (state, payload) => state.alturas = payload,
    },
    actions: {
        refresh_alturas({commit}, payload) {
            commit('SET_ALTURAS', payload)
        }
    }
}